module.exports = {"150703001":"第三街道","150703002":"第一街道","150703003":"第二街道","150703004":"第四街道","150703005":"第五街道","150703100":"灵泉镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150703.json
// module id = 400
// module chunks = 0